var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM13 13C14.6569 13 16 11.6569 16 10C16 8.34315 14.6569 7 13 7C11.3431 7 10 8.34315 10 10C10 11.6569 11.3431 13 13 13ZM13 16C16.3137 16 19 13.3137 19 10C19 6.68629 16.3137 4 13 4C9.68629 4 7 6.68629 7 10C7 13.3137 9.68629 16 13 16ZM13 19C14.6569 19 16 17.6569 16 16H19C19 19.3137 16.3137 22 13 22C9.68629 22 7 19.3137 7 16H10C10 17.6569 11.3431 19 13 19Z"}));
}

Logo.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"#31383F"};

module.exports = Logo;

Logo.default = Logo;
